"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowEmptyEnum = exports.getEnumText = exports.getEnumOptions = void 0;
var enum_1 = require("remota-common/enum");
var util_1 = require("remota-common/util");
var options = (_a = {},
    _a[util_1.EnumKeys.DETAIL_TAX_TYPE] = [
        { text: "外税", value: enum_1.DetailTaxType.EXCLUSIVE },
        { text: "内税", value: enum_1.DetailTaxType.INCLUSIVE },
    ],
    _a[util_1.EnumKeys.BILLED_FROM] = [
        { text: "国内", value: enum_1.BilledFrom.DOMESTIC },
        { text: "海外", value: enum_1.BilledFrom.OVERSEAS },
    ],
    _a[util_1.EnumKeys.PAID_CURRENCY] = [
        { text: "JPY (日本・円)", value: enum_1.PaidCurrency.JPY },
        { text: "USD (アメリカ合衆国ドル)", value: enum_1.PaidCurrency.USD },
        { text: "EUR (ユーロ)", value: enum_1.PaidCurrency.EUR },
        { text: "CNY / RMB (中国・人民元)", value: enum_1.PaidCurrency.CNY },
        { text: "HKD (香港ドル)", value: enum_1.PaidCurrency.HKD },
        { text: "--------------------", value: "--------------------", disabled: true },
        { text: "AED (UAEディルハム)", value: enum_1.PaidCurrency.AED },
        { text: "AUD (オーストラリア・ドル)", value: enum_1.PaidCurrency.AUD },
        { text: "BDT (バングラデシュ・タカ)", value: enum_1.PaidCurrency.BDT },
        { text: "BRL (ブラジル・レアル)", value: enum_1.PaidCurrency.BRL },
        { text: "CAD (カナダ・ドル)", value: enum_1.PaidCurrency.CAD },
        { text: "CHF (スイス・フラン)", value: enum_1.PaidCurrency.CHF },
        { text: "DKK (デンマーク・クローネ)", value: enum_1.PaidCurrency.DKK },
        { text: "GBP (スターリング・ポンド)", value: enum_1.PaidCurrency.GBP },
        { text: "HUF (ハンガリー・フォリント)", value: enum_1.PaidCurrency.HUF },
        { text: "IDR (インドネシア・ルピア)", value: enum_1.PaidCurrency.IDR },
        { text: "INR (インド・ルピー)", value: enum_1.PaidCurrency.INR },
        { text: "KRW (大韓民国ウォン)", value: enum_1.PaidCurrency.KRW },
        { text: "MXN (メキシコ・ペソ)", value: enum_1.PaidCurrency.MXN },
        { text: "MYR (マレーシア・リンギット)", value: enum_1.PaidCurrency.MYR },
        { text: "NOK (ノルウェー・クローネ)", value: enum_1.PaidCurrency.NOK },
        { text: "NZD (ニュージーランド・ドル)", value: enum_1.PaidCurrency.NZD },
        { text: "PHP (フィリピン・ペソ)", value: enum_1.PaidCurrency.PHP },
        { text: "PLN (ポーランド・ズウォティ)", value: enum_1.PaidCurrency.PLN },
        { text: "RUB (ロシア・ルーブル)", value: enum_1.PaidCurrency.RUB },
        { text: "SEK (スウェーデン・クローナ)", value: enum_1.PaidCurrency.SEK },
        { text: "SGD (シンガポール・ドル)", value: enum_1.PaidCurrency.SGD },
        { text: "THB (タイ・バーツ)", value: enum_1.PaidCurrency.THB },
        { text: "TRY (トルコリラ)", value: enum_1.PaidCurrency.TRY },
        { text: "TWD (ニュー台湾ドル)", value: enum_1.PaidCurrency.TWD },
        { text: "VND (ベトナム・ドン)", value: enum_1.PaidCurrency.VND },
        { text: "ZAR (ランド)", value: enum_1.PaidCurrency.ZAR },
    ],
    _a);
var isAllowEmpty = (_b = {},
    _b[util_1.EnumKeys.DETAIL_TAX_TYPE] = false,
    _b[util_1.EnumKeys.BILLED_FROM] = true,
    _b[util_1.EnumKeys.PAID_CURRENCY] = true,
    _b);
var getEnumOptions = function (key) {
    return options[key] || [];
};
exports.getEnumOptions = getEnumOptions;
var getEnumText = function (key, value) { var _a; return ((_a = (0, exports.getEnumOptions)(key).find(function (option) { return option.value === value; })) === null || _a === void 0 ? void 0 : _a.text) || ""; };
exports.getEnumText = getEnumText;
var isAllowEmptyEnum = function (key) { return isAllowEmpty[key] || false; };
exports.isAllowEmptyEnum = isAllowEmptyEnum;
